import { render, staticRenderFns } from "./assess.vue?vue&type=template&id=6e610ddc&scoped=true"
import script from "./assess.vue?vue&type=script&lang=js"
export * from "./assess.vue?vue&type=script&lang=js"
import style0 from "./assess.vue?vue&type=style&index=0&id=6e610ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e610ddc",
  null
  
)

export default component.exports